import { ACTION_RESULTS_PATH } from "../../framework/firebase/DBPathConstants";
import { GameIdFirebaseWrapper } from "../../framework/firebase/GameIdFirebaseWrapper";
import { DataListener } from "../../framework/layer/DataListener";
export class ActionResultDataListener extends DataListener {
    constructor(firebase, playerAndGameIdProvider) {
        super({
            firebase,
            listen: {
                listPath: '',
            }
        });
        this.playerId = '';
        this.playerAndGameIdProvider = playerAndGameIdProvider;
        this.firebase = firebase;
    }
    activate() {
        this.playerId = this.playerAndGameIdProvider.data.playerId;
        const gameId = this.playerAndGameIdProvider.data.gameId;
        this.config.firebase = new GameIdFirebaseWrapper(this.firebase, gameId);
        this.config.listen.listPath = `${ACTION_RESULTS_PATH}/${this.playerId}`;
        super.activate();
    }
}
//# sourceMappingURL=ActionResultDataListener.js.map